// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Auth reducers and selectors
import { AppState } from '../../../core/reducers/';
import { isLoggedIn } from '../_selectors/auth.selectors';
import { UserService } from '../../_services/user.service';
    import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as jwt_decode from 'jwt-decode';
import { environment } from '../../../../environments/environment';


@Injectable()
export class AuthGuard  {
    constructor(private store: Store<AppState>, private router: Router,private userService:UserService) { }




canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.pipe(
        select(isLoggedIn),
        map(loggedIn => {
            const token = localStorage.getItem(environment.authTokenKey);
            if (!loggedIn || !token) {
                this.router.navigateByUrl('/auth/login');
                return false;
            }

            try {
                const decoded: any = jwt_decode(token);
                const now = Math.floor(Date.now() / 1000);
                if (decoded.exp && decoded.exp < now) {
                    this.router.navigateByUrl('/auth/login');
                    return false;
                }
            } catch (e) {
                this.router.navigateByUrl('/auth/login');
                return false;
            }

            const requiredGrant = route.data['requiredGrant'];
            const currentUser = this.userService.getAuth();

            if (requiredGrant && currentUser?.grants !== requiredGrant) {
                this.router.navigateByUrl('/error/403');
                return false;
            }

            return true;
        })
    );
}



}
